/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from './app/locales/en/common.json';
import translationFR from './app/locales/fr/common.json';

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
};

interface Options {
  order: Array<string>;
  lookupQuerystring: string;
  lookupCookie: string;
  lookupLocalStorage: string;
  lookupSessionStorage: string;
  lookupFromPathIndex: number;
  lookupFromSubdomainIndex: number;
}

const options: Options = {
  order: [
    'path',
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag',
    'subdomain',
  ],

  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupSessionStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    nonExplicitSupportedLngs: false,
    load: 'languageOnly',
    lowerCaseLng: true,
    react: {
      useSuspense: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
